import type { Entry } from 'contentful';

import type { PageProps } from '@libs/core';

import { buildPage } from '../../utils';
import { applyHomepageCampaignHeroH1 } from './apply-homepage-campaign-hero-h1';
import { OptexHomepageBiaGuest } from './components/optex-homepage-bia-guest';

export default function HomePage({ entry }: PageProps) {
    const items = entry?.fields?.items as Entry[] | undefined;

    if (items) {
        applyHomepageCampaignHeroH1(items);
    }

    return (
        <>
            {buildPage(items as Entry[])}
            <OptexHomepageBiaGuest />
        </>
    );
}
